import React, { Component } from 'react'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { APIS } from '../../../../../../utils/api-factory';
import Loader from '../../../../../presentationals/Loader/Loader.component'

import { _formatDateInDash } from '../../../../../../utils/validation';
import { sendverificationRequestApi } from '../../../AdminActionCreator.component'

import Basic from './detailingpageEv.container'

import { TENANT_HEADER } from '../../../../../../utils/apiHeaders';

class BasicUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmationPopup: false,
            confirmationText: '',
            loaderState: false,
            creditScoringPopup: false,
            popupState: false,
            popupStatus: '',
            senderMailId: '',
            allDetail: this.props.allDetail,
            mailIdForVerification: '',
            pageViewState: '',
            linkState: false,
            cibilScoringTabState: false,
            creditScoreTabState: false,
            teaGardenId: '',
            teaGardenData: '',
            teaEdit: false,
            reasonData: ''
        }
    }
    tabsHandler(type, statetoset) {
        // console.log(type)
        if (type == 'cibilScoring') {
            if (this.state.cibilScoringTabState === true) {
                this.setState({ cibilScoringTabState: false })
            } else {
                this.setState({ cibilScoringTabState: true })
            }

        }
        if (type == 'creditScore') {
            if (this.state.creditScoreTabState === true) {
                this.setState({ creditScoreTabState: false })
            } else {
                this.setState({ creditScoreTabState: true })

            }
        }

    }

    userLinkHandler() {
        this.setState({ linkState: true })
    }
    componentDidMount() {
        const { allDetail, admin, showEditPorfile, showCrifDataTab, userDetail } = this.props;
        // console.log(this.props)
        this.setState({ loaderState: true })
        fetch(APIS.GET_USERS_DETAILS_BY_USER_ID + userDetail.userId)
            .then(res => res.json())
            .then(json => {
                if (Object.entries(json).length !== 0 && json.UserToEmpId.teaGardenId !== null && json.UserToEmpId.teaGardenId !== undefined) {
                    this.setState({ teaGardenId: json.UserToEmpId.teaGardenId, loaderState: false, teaGardenData: json, teaEdit: true, pageViewState: 'basicPageTea' })
                } else {
                    this.setState({ loaderState: false, teaEdit: false, pageViewState: 'basicPage' })

                }
            })
        fetch(APIS.GET_REASONS_API + userDetail.loanId,TENANT_HEADER)
            .then(response => {
                if (!response.ok) {
                    //   throw new Error(`HTTP error! status: ${response.status}`);
                    const contentType = response.headers.get('content-type');
                    if (!contentType || !contentType.includes('application/json')) {
                        throw new Error('Response is not JSON');
                    }

                    return response.json();
                }
            })
            .then(json => {
                this.setState({ reasonData: json })
            })
    }

    render() {
        const { allDetail, allStatus, admin, showEditPorfile, showCrifDataTab, userDetail,handlePageState } = this.props;
        return (
            <div>
                

                {this.state.loaderState ?
                    <Loader />
                    : ""}
                

                {this.state.pageViewState == 'basicPage' ?
                    <div>
                        
                        <Basic
                            UserDetailTabsHandler={this.props.UserDetailTabsHandler}
                            allStatus={allStatus}
                            userDetailHandler={this.props.userDetailHandler}
                            reasonData={this.state.reasonData}
                            userLinkHandler={this.userLinkHandler.bind(this)}
                            linkState={this.state.linkState}
                            userDetail={userDetail}
                            closePopup={this.closePopup.bind(this)}
                            popupStatus={this.state.popupStatus}
                            allDetail={allDetail}
                            getCreditPopupState={this.getCreditPopupState.bind(this)}
                            creditScoringPopup={this.state.creditScoringPopup}
                            admin={admin}
                            cancelLoanConfirm={this.cancelLoanConfirm.bind(this)}
                            confirmationText={this.state.confirmationText}
                            arr={this.state.arr}
                tenant={this.props.tenant}
                handlePageState={handlePageState}
                            
                        />
                    </div>
                    : null}
            </div>
        )
    }




    sendHandler(type) {
        this.setState({
            pageViewState: type,
        })
    }
    ConfirmCrifDataGenerate(dataType) {
        if (dataType == 'yes') {
            this.setState({
                pageViewState: 'crifData'
            })

        } if (dataType == 'no') {
            this.setState({
                pageViewState: 'basicPage'
            })
        }
    }


    cancelLoanConfirm(conType) {
        if (conType == 'yes') {
            sendverificationRequestApi(this.state.mailIdForVerification,
                (callBack) => {
                    if (callBack == 'success') {
                        this.setState({
                            popupState: true,
                            popupStatus: 'Mail has been successfully sent to user.',
                            confirmationPopup: false
                        })
                        this.removePopup()
                    } else {
                        this.setState({
                            popupState: true,
                            popupStatus: 'Please try again.',
                            confirmationPopup: false
                        })
                        this.removePopup()
                    }
                })
        } else if (conType == 'no') {
            this.setState({ confirmationPopup: false })
        }
    }

    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false });
        }.bind(this), 5000)
    }

    closePopup() {
        this.setState({ popupState: false });
    }


    getCreditPopupState(state) {
        this.props.getCreditPopupState(state)
    }

    detailBackHandler() {
        this.props.basicBackHandler()
    }

    verifyMail(mailId) {
        this.setState({
            mailIdForVerification: mailId,
            confirmationText: 'Are you sure for send verification mail to this user?',
            confirmationPopup: true
        })

    }

    componentWillUnmount() {

    }

}
const mapStateToProps = ({ pendingDetail }) => {
    return {
        pendingDetail: pendingDetail
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(BasicUser);